import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppRoutes } from './routes';


const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>

      {/* ✅ STRIPE WRAPPER ADDED (ONLY CHANGE) */}
        <Router>
          <ScrollToTop />
          <div className="min-h-screen bg-white flex flex-col">
            <main className="flex-grow">
              <AppRoutes />
            </main>
          </div>
        </Router>

    </QueryClientProvider>
  );
}

export default App;